import { z } from 'zod';
import { userDtoSchema } from './user.js';
export const telegramAuthRequestSchema = z.object({
    initData: z.string().min(1).max(8192),
});
export const telegramWidgetAuthSchema = z.object({
    id: z.number().int(),
    first_name: z.string(),
    last_name: z.string().optional(),
    username: z.string().optional(),
    photo_url: z.string().url().optional(),
    auth_date: z.number().int(),
    hash: z.string().length(64),
});
export const authTokensSchema = z.object({
    accessToken: z.string(),
    user: userDtoSchema,
});
